export abstract class EmailValidator {
  /**
   * Regular expression for validating an email address.
   *
   * This regex ensures the email follows the general pattern:
   * `<local-part>@<domain>.<tld>`, and does not contain spaces or invalid characters.
   */
  private static readonly emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /**
   * Validates an email address using a regular expression.
   *
   * @param {string} email - The email address to validate.
   * @returns {boolean} `true` if the email address is valid; otherwise, `false`.
   */
  static validateEmail(email: string): boolean {
    return EmailValidator.emailRegex.test(email);
  }
}
